import React, { useEffect, useState } from "react";
import axios from "axios";
import "./PatientDetails.css";

import { useParams, useNavigate } from "react-router-dom";
import "../programsdetails/ProgramsDetails.css";
import PersonalInfo from "../../components/personalinfo/PersonalInfo";
import Community from "../../components/communitydetails/Community";
import PatientProgramDetails from "../../components/patientprogramdetails/PatientProgramDetails";
import PainScore from "../../components/painscore/PainScore";
import AdlScore from "../../components/adlscore/AdlScore";
import OdiScore from "../../components/odiscore/OdiScore";
import RomScore from "../../components/romscore/RomScore";
import PatientMessages from "../../components/patientmessages/PatientMessages";
import PatientAnswers from "../../components/patientanswers/PatientAnswers";
import TherapistsWithRoles from "../../components/therapistswithroles/TherapistsWithRoles";
import PatientNotes from "../../components/patientNotes/PatientNotes";
//import AddToTeam from "../../components/addtoteam/AddToTeam";

const PatientDetails = (props) => {
  const [patientName, setPatientName] = useState("");
  const [permitions, setPermitions] = useState({});
  const [openTab, setOpenTab] = useState("overview");
  const [patientNotes, setPatientNotes] = useState([]);
  const [savedNote, setSavedNote] = useState(false);
  const isCompanyAdmin =
    localStorage.getItem("userData") &&
    JSON.parse(localStorage.getItem("userData"))
      ? JSON.parse(localStorage.getItem("userData")).company_admin === 1
        ? true
        : false
      : false;
  const isSuperAdmin =
    localStorage.getItem("userData") &&
    JSON.parse(localStorage.getItem("userData"))
      ? JSON.parse(localStorage.getItem("userData")).super_admin === 1
        ? true
        : false
      : false;
  useEffect(() => {
    window.onbeforeunload = null;
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    props.actSidebar(false);
    setPatPage(document.getElementById("pat_page"));
  }, [props]);
  let { id } = useParams();
  let { program_id } = useParams();
  let navigate = useNavigate();
  useEffect(() => {
    axios.defaults.headers.common["Authorization"] = JSON.parse(
      localStorage.getItem("userData")
    ).token;
    axios
      .post(window.ajaxLink + "cloud_therapist/therapist_permissions", { id })
      .then((res) => {
        if (res.data.responseData) {
          if (!res.data.responseData.view_file && !isSuperAdmin) {
            setPermissionMessage(
              JSON.parse(localStorage.getItem("isOpenTherapist")) === true
                ? "You do not have permission to see this therapist’s details."
                : "You do not have permission to see this patient’s details."
            );
          }
          setPermitions(res.data.responseData);
          localStorage.removeItem("imported_tasks");
          localStorage.removeItem("inserted_activities");
          localStorage.removeItem("deleted_activities");
          localStorage.removeItem("inserted_tasks");
          localStorage.removeItem("deleted_tasks");
          localStorage.removeItem("start_date");
          localStorage.removeItem("as_template");
          localStorage.removeItem("is_assigned");
        }
      })
      .catch((error) => {
        console.error(error);
      });
      // eslint-disable-next-line
  }, [openTab]);

  useEffect(() => {
    axios.defaults.headers.common["Authorization"] = JSON.parse(
      localStorage.getItem("userData")
    ).token;
    axios
      .post(window.ajaxLink + "cloud_therapist/get_patient_notes", { id })
      .then((res) => {
        if (res.data.responseData) {
          setPatientNotes(res.data.responseData);
          setSavedNote(false);
        }
      })
      .catch((error) => {
        console.error(error);
      });
      // eslint-disable-next-line
  }, [savedNote]);

  const [patPage, setPatPage] = useState({});
  const [isAnswersOpen, setAnswersOpen] = useState(false);
  const [answersLoaded, setAnswersLoaded] = useState(false);
  const [answersInfo, setAnswersInfo] = useState([]);
  const [permissionMessage, setPermissionMessage] = useState("");

  const saveNote = () => {
    setSavedNote(true);
  };

  const openCloseAnswers = (through_tab) => {
    if (through_tab) {
      setOpenTab("questionnaires");
    }
    if (!isAnswersOpen || through_tab) {
      axios.defaults.headers.common["Authorization"] = JSON.parse(
        localStorage.getItem("userData")
      ).token;
      axios
        .post(window.ajaxLink + "cloud_therapist/patient-answers", { id })
        .then((res) => {
          if (res.data.responseData) {
            setAnswersInfo(res.data.responseData);
            setAnswersLoaded(true);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    } else {
      setAnswersInfo([]);
      setAnswersLoaded(false);
    }
    if (!through_tab) {
      setAnswersOpen(!isAnswersOpen);
    }
  };


  // const [isTeamOpen, setTeamOpen] = useState(false);
  // eslint-disable-next-line
  const [isTeamAdded, setTeamAdded] = useState(false);
  const openCloseAddTeam = (addTeamMembers) => {
    // if (addTeamMembers && addTeamMembers.length > 0) {
    //   var testArr = [];
    //   for (var singleMember of addTeamMembers) {
    //     testArr.push(singleMember.therapist_id);
    //   }
    //   axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
    //   axios
    //     .post(window.ajaxLink + "cloud_therapist/add-therapists-to-team", {new_members: testArr})
    //     .then(() => setTeamAdded(!isTeamAdded))
    //     .catch((error) => {
    //       console.log(error);
    //     });
    // }
    // setTeamOpen(!isTeamOpen);
    navigate(`/add-care-team/${id}/${program_id}`);
  };

  const handleToDashboard = () => {
    localStorage.removeItem("from_dash");
    navigate("/dashboard");
  };

  const handleToMessages = () => {
    if (localStorage.getItem("from_messages") == null) {
      navigate("/myPatients");
    } else {
      navigate(`/messages/${id}`);
    }
    localStorage.removeItem("from_messages");
  };

  return (
    <div id="pat_page" style={{ flex: 1 }}>
      {permitions.view_file || isCompanyAdmin || isSuperAdmin ? (
        <>
          <div
            className="ptdetails_content_holder"
            style={{
              padding: "1rem 2rem",
              flexDirection: "column",
              background: "#fff",
              borderRadius: "24px",
              overflow: "hidden",
              marginTop: '24px'
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
              className="prog_det_back"
            >
              {localStorage.getItem("from_dash") == null ? (
                <div onClick={() => handleToMessages()}>
                  <div className="prog_back_icon"></div>
                  <div className="prog_det_back_text">
                    Back to{" "}
                    {localStorage.getItem("from_messages") == null
                      ? "Patients"
                      : "Messages"}
                  </div>
                </div>
              ) : (
                <div onClick={() => handleToDashboard()}>
                  <div className="prog_back_icon"></div>
                  <div className="prog_det_back_text">Back to Dashboard </div>
                </div>
              )}
            </div>
            {/* <div className={"prog_det_title_hold" + (openTab === "overview" ? " patient_list_resize" : " team_resize")}> */}
            
            <div
              style={{ margin: 0, marginTop: "10px", display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', flex: 1 }}
              className={"prog_det_title_hold patient_list_resize"}
            >
              <div className="prog_det_title">{patientName}</div>
            
            <div className="assessment_btn_holder">
              {(permitions.ce_assessment || isCompanyAdmin) &&
                openTab === "overview" && (
                  <div
                    className="prog_edit_btn patient_scnd_btn"
                    onClick={() =>
                      navigate("/patient-assesment/25/" + id + "/" + program_id)
                    }
                  >
                    Initial Evaluation
                  </div>
                )}
              {openTab === "team" && isCompanyAdmin && (
                <div
                  className="prog_edit_btn patient_scnd_btn"
                  onClick={() => openCloseAddTeam()}
                >
                  Edit Care Team
                </div>
              )}
            </div>
            </div>
          </div>
		  
          <div style={{ flex: 1 }}>
            <div className="patient_dets_tab_hold">
              <div className="patient_flex_display">
                <div
                  className={
                    "patient_tab_name " +
                    (openTab === "overview" ? "patient_tab_name_sel" : "")
                  }
                  onClick={() => setOpenTab("overview")}
                >
                  Overview
                </div>
                <div
                  className={
                    "patient_tab_name " +
                    (openTab === "community" ? "patient_tab_name_sel" : "")
                  }
                  onClick={() => setOpenTab("community")}
                >
                  Support Team
                </div>
                <div
                  className={
                    "patient_tab_name " +
                    (openTab === "questionnaires" ? "patient_tab_name_sel" : "")
                  }
                  onClick={() => openCloseAnswers(true)}
                >
                  Questionnaires
                </div>
                <div
                  className={
                    "patient_tab_name" +
                    (openTab === "team" ? " patient_tab_name_sel" : "")
                  }
                  onClick={() => setOpenTab("team")}
                >
                  Care Team
                </div>
                <div
                  className={
                    "patient_tab_name" +
                    (openTab === "notes" ? " patient_tab_name_sel" : "")
                  }
                  onClick={() => setOpenTab("notes")}
                >
                  Notes ({patientNotes.length})
                </div>
              </div>
              <div
                className={
                  "patient_tab_sel_slide" +
                  (openTab === "community"
                    ? " ptab_opt2"
                    : openTab === "questionnaires"
                    ? " ptab_opt3"
                    : openTab === "team"
                    ? " ptab_opt4"
                    : openTab === "notes"
                    ? " ptab_opt5"
                    : "")
                }
              ></div>
            </div>
            <div className="ptdetails_content_holder">
              {openTab === "overview" ? (
                <>
                  <div className="patient_details_container">
                    <div className="patient_details_holder patient_details_holder_left">
                      <PersonalInfo
                        setPatientName={setPatientName}
                        isCompanyAdmin={isCompanyAdmin}
                        permissions={permitions}
                      />
                    </div>
                    <div className="patient_details_holder patient_details_holder_middle">
                      <PatientProgramDetails />
                      <PainScore />
                      <AdlScore />
                      <OdiScore />
                      <RomScore id={id} />
                    </div>
                    <div className="patient_details_holder patient_details_holder_right">
                      <PatientMessages
                        permitions={permitions}
                        isCompanyAdmin={isCompanyAdmin}
                        isSuperAdmin={isSuperAdmin}
                      />
                    </div>
                  </div>
                  {isAnswersOpen && (
                    <PatientAnswers
                      pageHeight={patPage.scrollHeight + 320 + "px"}
                      answersLoaded={answersLoaded}
                      answersInfo={answersInfo}
                      openCloseAnswers={openCloseAnswers}
                    />
                  )}
                </>
              ) : openTab === "community" ? (
                <div  className="patient_details_container pat_dets_cont_adjusted">
                  <Community />
                </div>
              ) : openTab === "questionnaires" ? (
                <div className="patient_details_container pat_dets_cont_adjusted">
                  <PatientAnswers
                    onPage={true}
                    answersLoaded={answersLoaded}
                    answersInfo={answersInfo}
                    openCloseAnswers={openCloseAnswers}
                  />
                </div>
              ) : openTab === "team" ? (
                <>
                  <TherapistsWithRoles
                    isTeamOpen={isTeamAdded}
                    setOpenTab={setOpenTab}
                    currentPatient={id}
                  />
                </>
              ) : openTab === "notes" ? (
                <PatientNotes
                  patientNotes={patientNotes}
                  saveNote={saveNote}
                ></PatientNotes>
              ) : (
                ""
              )}
            </div>
          </div>
        </>
      ) : (
        <div className="prog_det_top_hold">{permissionMessage}</div>
      )}
    </div>
  );
};

export default PatientDetails;
